
$("#search_input").keyup(function (e) {
    if (e.target.value == "") {
        $(".location-top-section-input-remove").css("display", "none");
    } else {
        $(".location-top-section-input-remove").css("display", "block");
    }
});
const locationDetectionHelper = () => {
    const success = async (position) => {
      console.log("position", position);
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
        const apiGKey = "AIzaSyC0lN4DyVT43XI8s2CAQ3tIJnTJpK9Ni1E";
const sideBox1 = document.querySelector(".side-container .side-box");
                  $('#pac-input').val("");
              console.log("data add");
                var form = new FormData();
                  form.append("lat", lat);
                  form.append("lng", lng);
                  
                    $.ajax({
    url: starquik + "getlocationapi",
    method: "POST",
    timeout: 0,
    processData: false,
    contentType: false,
    data: form,
    success: function (response) {
      try {
        const res = typeof response === "string" ? JSON.parse(response) : response;

        if (res.status === true) {
          async function getGoogleLocation() {
const response = await fetch(
                            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiGKey}`
                        );
                        const jsonData = await response.json();
                        localStorage.setItem(
                            "GOOGLE_LOCATION",
                            JSON.stringify(jsonData.results[0])
                        );
                        const locality =
                            jsonData.results[0].address_components.filter(
                                (address) =>
                                address.types.includes("sublocality_level_1") == false ?  address.types.includes("locality"):address.types.includes("sublocality_level_1")                                 
                            )[0].short_name;
                        $(".select-location-label").empty();
                  console.log("locality", locality);
                        $(".select-location-label").append(`${locality} <img src="https://cdn.shopify.com/s/files/1/0678/1947/0941/files/map.png?v=1740646952" alt="Map" width="10px"
                            height="13px" /> `);
}
          getGoogleLocation();
          
          $(".service-not-applicable").html('');
          // $('.select-location-label').html(`
          //   ${longName} <img class="small-hide medium-hide" src="https://cdn.shopify.com/s/files/1/0678/1947/0941/files/map.png?v=1740646952" loading="lazy" alt="Map" width="10px" height="13px">
          // `);

          const { store_id, location_id, nearest_time, date } = res;
          const fullStoreId = `SC_${store_id}`;
          localStorage.setItem("store_id", fullStoreId);
          localStorage.setItem("location_id", location_id);

          const formattedDate = formatDateToReadable(date);
          const message = `Next available delivery slot: ${formattedDate} ${nearest_time}`;
          localStorage.setItem("delivery_slot_message", message);
          const deliverySlotElement = document.querySelector(".order-del-subpara");
          if (deliverySlotElement) {
            deliverySlotElement.innerText = message;
          }
          if (sideBox1) {
            setTimeout(() => {
              sideBox1.classList.remove("open-side");
            }, 200);
          }

          //console.log("store_id and location_id saved to localStorage");
        } else {
          console.warn("No stores found:", res.message || "Unknown error");
          clearLocationDataAndShowError();
        }
      } catch (e) {
        console.error("Failed to parse response:", e);
        clearLocationDataAndShowError();
      }
    },
    error: function () {
      clearLocationDataAndShowError();
    }
  });
              function clearLocationDataAndShowError() {
  localStorage.removeItem("store_id");
  localStorage.removeItem("location_id");
  localStorage.removeItem("delivery_slot_message");
  localStorage.removeItem("GOOGLE_LOCATION");

  $(".service-not-applicable").html(`
    <div class="service-not-applicable-box">
      <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
      <p class="service-not-applicable-para">
        Sorry! At the moment, we’re not delivering here. If we expand our service in the future, we’ll notify you. Watch this space for more & stay tuned!
      </p>
    </div>
  `);
}  
        
        // try {
        //   const response = await fetch(
        //     `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiGKey}`
        //   );
        //   const data = await response.json();
        //   if (data.status === "OK") {
        //      console.log("hello OK", data.results);
        //     localStorage.setItem("GOOGLE_LOCATION", JSON.stringify(data.results[0]));
        //     //  const postalCodeComp = components.find(comp =>
        //     //   comp.types.includes("postal_code")
        //     // );
        //     // if (postalCodeComp) {
        //     //   const postalCode = postalCodeComp.long_name;
        //     //   console.log("Postal Code:", postalCode);
        //     // } else {
        //     //   console.warn("Postal code not found in address components.");
        //     // }
            
        //     console.log("hello 1");
        //     if (lat && lng) {
        //       console.log("hello 2")
  
          
        //           console.log("hello", lat);
        //           console.log("hello", lng);
        //           // var locationData = localStorage.getItem('GOOGLE_LOCATION');
        //           // var locationObj = JSON.parse(locationData);
        //           // const subloComponent = place.address_components.find(component =>
        //           //   component.types.includes("sublocality_level_1")
        //           // );
        //           // if (subloComponent) {
        //           //   var longName = subloComponent.long_name;
        //           //   // localStorage.setItem("POSTAL_CODE", postalCode);
        //           //   // $(".postal-code-label").html(postalCode);
        //           // } else {
        //           //   var longName = locationObj.address_components[0].long_name;
        //           //   console.log("Postal code not found in address_components.");
        //           // }
                  
                  
        //           // let sideBox = document.querySelector(".side-container .side-box");
                  
  
        //         }else{
        //           localStorage.removeItem("store_id");
        //                 localStorage.removeItem("location_id");
        //                 localStorage.removeItem("GOOGLE_LOCATION");
        //           $(".service-not-applicable")
        //                     .html(`<div class="service-not-applicable-box">
        //                     <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
                            
        //                     <p class="service-not-applicable-para">Sorry! At the moment, we’re not delivering here. If we expand our service in the future, we’ll notify you. Watch this space for more & stay tuned!</p>
        //                     </div>`);
        //         }

            
        //   }else{
        //      $(".service-not-applicable")
        //                     .html(`<div class="service-not-applicable-box">
        //                     <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
                            
        //                     <p class="service-not-applicable-para">Sorry! At the moment, we’re not delivering here. If we expand our service in the future, we’ll notify you. Watch this space for more & stay tuned!</p>
        //                     </div>`);
        //   }
          
        //     } catch (err) {
        //    $(".service-not-applicable")
        //                     .html(`<div class="service-not-applicable-box">
        //                     <img src="https://cdn.shopify.com/s/files/1/0734/0566/1405/files/Location.png?v=1741862281" height="100px" width="100px" alt="location-unavailable"/>
                            
        //                     <p class="service-not-applicable-para">Sorry! At the moment, we’re not delivering here. If we expand our service in the future, we’ll notify you. Watch this space for more & stay tuned!</p>
        //                     </div>`);
        //   //console.error("Error calling Geocoding API:", err);
        // }
       
    };
    const failure = (error) => {
        //$(".loader_bg").hide();
        $(".service-not-applicable").empty();
        $(".service-not-applicable")
            .append(`<div class="service-not-applicable-box">
                            <img src="../../images/Empty/Location.png" height="100px" width="100px" alt="location-unavailable"/>
                            
                            <p class="service-not-applicable-para">${
                                error.code == 1
                                    ? "Please allow location access in site settings"
                                    : "We are unable to fetch your location. Please enter your location manually."
                            }</p>
                            </div>`);
        $("#location_custom_form_id").hide(200);
    };
    //$(".loader_bg").show();
    navigator.geolocation.getCurrentPosition(success, failure);
};
$(".location-top-section-detect").click(locationDetectionHelper);

// 2. Logic to run on page load if a store ID hasn't been saved yet
$(document).ready(function () {
    const savedStoreId = localStorage.getItem("store_id");
    const hasLocationData = localStorage.getItem("GOOGLE_LOCATION");
    
    // Check if we do NOT have a saved store ID OR saved Google location data.
    // This is a proxy for a first-time or failed visit.
    if (!savedStoreId || !hasLocationData) {
        console.log("No saved location found. Attempting automatic detection.");
        
        // --- Execute the location detection logic automatically ---
        // We run the helper function directly, without a click event.
        locationDetectionHelper();
    } else {
        // Optional: If you have a location, you might want to refresh the UI elements here
        // to prevent a flash of un-located content.
        console.log("Saved location found. Skipping automatic detection.");
    }
});

const StoreLocationOld = localStorage.getItem("LOCATION");
